import React, { useEffect, useState } from "react";
import Box from "@components/Box";
import Container from "@components/Container";
import CustomModal from "@components/CustomModal";
import DetailButton from "@components/DetailButton";
import InfoTable from "@components/InfoTable";
import LoadingSpinner from "@components/LoadingSpinner";
import LogisticService from "@LogisticService";
import { Link } from "../styles";
import DetalhesOS from "./DetalhesOS";

export default function RealizadosDistrito(props) {
  const title = "OSs Realizadas";
  const [ossRealizadasDistrito, setOssRealizadasDistrito] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [visibleModal, setVisibleModal] = useState(undefined);
  const [visibleDetalhesOs, setVisibleDetalhesOs] = useState(false);
  const [oSSelecionada, setOSSelecionada] = useState(undefined);

  useEffect(() => {
    LogisticService.getRealizadosDistrito(props.id_distrito).then(
      (response) => {
        setOssRealizadasDistrito(response.data);
        setLoaded(true);
      }
    );
  }, [props.id_distrito]);

  const colunas = [
    {
      label: "Polo",
      key: "polo",
      align: "start",
      sort: {
        compare: (a, b) => a.distrito.localeCompare(b.distrito),
      },
    },
    { label: "Feitas Hoje", key: "feitas_hoje" },
    { label: "Pendentes em atraso", key: "pendentes_em_atraso" },
    { label: "Novas", key: "NOVA" },
    { label: "Recebidas", key: "RECEBIDA" },
    { label: "Em Campo", key: "EM CAMPO" },
    { label: "Repiques", key: "REPIQUE" },
  ];

  const labelsModal = {
    feitas_hoje: "Feitas Hoje",
    pendentes_em_atraso: "Pendentes Em Atraso",
    NOVA: "Novas",
    RECEBIDA: "Recebidas",
    "EM CAMPO": "em Campo",
    REPIQUE: "em Repique",
  };

  const rows = [];
  const downloadLabels = colunas.map((item) => item.label);
  const downloadData = [];
  const modalData = [];

  for (let polo in ossRealizadasDistrito) {
    const row = { polo: polo };
    const rowDownload = [polo];
    let count = 0;

    for (let status in ossRealizadasDistrito[polo]) {
      const id = polo.split(" - ")[1] + count;
      const numOss = ossRealizadasDistrito[polo][status].length;

      if (numOss > 0) {
        row[status] = (
          <>
            {numOss}
            <DetailButton onClick={() => setVisibleModal(id)} />
          </>
        );
      }
      rowDownload.push(numOss);

      modalData.push(
        <CustomModal
          title={`OSs ${labelsModal[status]} no ${polo}`}
          key={id}
          visible={visibleModal === id}
          zIndex={1000}
          onCancel={() => setVisibleModal(undefined)}
          footer={null}
        >
          <Box maxHeight={"400px"} margin={"0"} padding={"0"} scroll>
            {ossRealizadasDistrito[polo][status].map((os) => (
              <Link
                onClick={() => {
                  setOSSelecionada(os);
                  setVisibleDetalhesOs(true);
                }}
              >
                {os}
              </Link>
            ))}
          </Box>
        </CustomModal>
      );

      count += 1;
    }
    downloadData.push(rowDownload);
    rows.push(row);
  }

  const tableData = {
    data: rows,
    columns: colunas,
  };

  useEffect(() => {
    if (downloadData.length > 0) {
      props.downloadAll.push({
        index: props.index,
        title: title,
        labels: downloadLabels,
        data: downloadData,
      });
    }
  }, [loaded]);

  return (
    <Container
      title={title + " - " + props.name}
      info={[`OSs Realizadas ${props.name}`]}
      downloadLabels={loaded ? downloadLabels : []}
      downloadData={loaded ? downloadData : []}
    >
      {loaded ? <InfoTable data={tableData} /> : <LoadingSpinner />}
      <CustomModal
        title={`Detalhes OS ${oSSelecionada}`}
        visible={visibleDetalhesOs}
        zIndex={1010}
        onCancel={() => setVisibleDetalhesOs(false)}
        footer={null}
      >
        <DetalhesOS os={oSSelecionada} />
      </CustomModal>
      {modalData}
    </Container>
  );
}
